import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import PercentageProgressBarWithHeading from './components/PercentageProgressBarWithHeading';
import { LEAD_TYPE_IDS } from 'helpers/sf_constants';
import { capitalizeFirstLetter } from 'helpers/sf_utils';
import { formatPhoneNumber } from 'helpers/quote_funnel_helper';
const Header = ({ answer_agent_profile, stepper, progress_percentage, lead_type_id, user_name, tracking_number, answer_agent_profile_loading, phone_number_text }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const updateIsMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', updateIsMobile);
        return () => {
            window.removeEventListener('resize', updateIsMobile);
        };
    }, []);
    let HEADING_HTML = "";

    switch (lead_type_id) {
        case LEAD_TYPE_IDS.AUTO:
            HEADING_HTML = "Car Insurance Quote";
            break;
        case LEAD_TYPE_IDS.HOME:
            HEADING_HTML = "Home Insurance Quote";
            break;
        case LEAD_TYPE_IDS.HEALTH:
            HEADING_HTML = "Health Insurance Quote";
            break;
        case LEAD_TYPE_IDS.MEDICARE:
            HEADING_HTML = "Medicare Advantage Quote";
            break;
        case LEAD_TYPE_IDS.LIFE:
            HEADING_HTML = "Life Insurance Quote";
            break;
        case LEAD_TYPE_IDS.COMMERCIAL:
            HEADING_HTML = "Business Insurance Quote";
            break;
        default:
            break;
    }

    return (
        <div className="heading-quote-funnel-answer-progress" style={{ padding: 0 }}>
            <Container>
                <div className="d-flex justify-content-between py-3">
                    <div className="d-flex align-items-center">
                        {
                            !answer_agent_profile_loading && <img src={answer_agent_profile?.company_logo_url} alt='' className="quote-funnel-company-logo" />
                        }
                    </div>
                    <div className="d-flex align-items-center">
                        {isMobile ? (
                            <a
                                className="btn btn-primary fw-bold font-size-18"
                                style={{
                                    backgroundColor: '#36b04b',
                                    width: '120px',
                                    marginRight: '14px',
                                    borderRadius: '6px',
                                    height: '44px',
                                    borderColor:  '#36b04b'
                                }}
                                href={`tel:${phone_number_text ? phone_number_text : tracking_number || ''}`}
                            >
                                Call Now
                            </a>
                        ) : (
                            <span className="text-bold fs-24">
                                <i
                                    className="bx bx-phone-call text-sfblue mx-1"
                                    style={{
                                        color: '#3486e5',
                                    }}
                                ></i>
                                {phone_number_text ? formatPhoneNumber(phone_number_text) : formatPhoneNumber(tracking_number)}
                            </span>
                        )}
                    </div>
                </div>
            </Container>
            {
                stepper ? (
                    <div className="bg-light py-4">
                        <div className="container">
                            <div className="col-md-10 col-sm-12 col-xs-12 mx-auto col-lg-9 text-center">
                                <span className="quote-funnel-fs-24">
                                    {user_name || ""} Get a Personalized {HEADING_HTML} From <span className='fw-bold'>{answer_agent_profile?.name}</span>
                                </span>
                                {
                                    <div className="quote-funnel-progress-bar mt-1">
                                        <PercentageProgressBarWithHeading percent={progress_percentage} navigate={true} css={null} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ) : stepper === false ? (
                    <div className="py-2 " style={{ marginTop: '16px' }}>
                        <div className="text-center mx-4">
                            <span className="fs-24">
                                <h1 className='quote-funnel-answer-header'> {!!user_name ? (capitalizeFirstLetter(user_name) + ", ") : ""} Your Personalized Quote is Ready.</h1>
                            </span>
                            <div className="d-flex justify-content-center align-items-center">
                                <div className='quote-funnel-answer-footer-img'>
                                    {answer_agent_profile?.profile_img_url && <img src={answer_agent_profile?.profile_img_url} alt="User Logo" className="quote-funnel-answer-footer-user-log" />}
                                </div>
                                <div className='responsive-mb'>
                                    <div className='ms-3' style={{ fontSize: '22px' }}>
                                        <span className='fw-bold' id="nameSpan">{answer_agent_profile?.name}</span>
                                        <span className='upward-slash'>{" | "}</span>
                                        <span className='responsive-fw-bold' id="locationSpan">{answer_agent_profile?.city}, {answer_agent_profile?.state}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : ""
            }
        </div>
    )
}

Header.propTypes = {
    answer_agent_profile: PropTypes.object
};
export default Header
